export enum FeedActionTypes {
  GET_FEED_REQUEST = '[Feed] GET_FEED_REQUEST',
  GET_FEED_SUCCESS = '[Feed] GET_FEED_SUCCESS',
  GET_FEED_ERROR = '[Feed] GET_FEED_ERROR',
}
